
import BirthdayList from '@/components/panel/BirthdayList';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/birthdays')({
    component: BirthdaysPage,
})

function BirthdaysPage() {

    return (
        <>
            <BirthdayList />
        </>
    )

}
